export default __webpack_public_path__ + "static/media/spinner.30e900c6.gif";